export type RecaptchaResult = {
  success: boolean;
  challenge_ts?: string;
  hostname?: string;
  score?: number;
  "error-codes"?: string[];
  action?: string;
};

export const getCaptchaToken = async (action: string, siteKey?: string) => {
  return new Promise<string>((resolve, reject) => {
    (window as any)?.grecaptcha
      .execute(siteKey, {
        action,
      })
      .then(function (token: string) {
        return resolve(token);
      })
      .catch((e: any) => reject(e));
  });
};
